"use client"

import {
  InfiniteTable,
  TableSkeleton,
} from "@/app/components/infinite-table/infinite-table"
import { HeaderRow } from "@/app/components/table"
import type { DropActivity } from "@anaconda/core/drop/types"
import { TableRow, cn } from "@rarible_int/anaconda_ui_components"
import { Cell } from "./cells"
import { COLUMNS } from "./columns"
import { useActivityItems } from "./use-activity-items"

const COMPONENTS = {
  HeaderRow: DropHeaderRow,
  RowContent,
  RowSkeleton,
  TableRow: ({
    className,
    ...props
  }: React.ComponentProps<typeof TableRow>) => {
    return (
      <TableRow
        className={cn("border-none", className)}
        {...props}
        data-testid="nft-drop-activity"
      />
    )
  },
} as const

const getItemKey = (item: DropActivity) => item.id

export function DropActivityTable() {
  const { items, loadNext } = useActivityItems()

  return (
    <InfiniteTable
      getItemKey={getItemKey}
      items={items}
      loadNext={loadNext}
      components={COMPONENTS}
      useWindowScroll={false}
      initialItemCount={15}
    />
  )
}

export function DropActivityTableSkeleton() {
  return <TableSkeleton HeaderRow={DropHeaderRow} RowSkeleton={RowSkeleton} />
}

function DropHeaderRow() {
  return (
    <HeaderRow>
      {COLUMNS.map((column, index) => (
        <column.Header key={index} />
      ))}
    </HeaderRow>
  )
}

function RowContent({ content }: { content: DropActivity }) {
  return (
    <>
      {COLUMNS.map((column, index) => (
        <column.Content key={index} {...content} />
      ))}
    </>
  )
}

function RowSkeleton() {
  return (
    <>
      {COLUMNS.map((column, index) => (
        <Cell key={index}>
          <column.Skeleton />
        </Cell>
      ))}
    </>
  )
}
